module.exports = __webpack_public_path__ + "static/media/hall-P2.4ce6ce97.svg";